<template>
  <div
    class="optimized-score-summary"
    @mouseenter="isMouseOver = true"
    @mouseleave="isMouseOver = false"
  >
    <slot></slot>
    <div
      v-if="isMouseOver"
      ref="table"
      class="optimized-score-summary__summary-table"
      :style="listStyle"
    >
      <div
        class="optimized-score-summary__summary-table_row"
        style="background-color: rgba(1,22,39,.1)"
      >
        <div
          v-for="column in tableConfig"
          :key="column.property"
          class="optimized-score-summary__summary-table_header"
          :class="[`optimized-score-summary__summary-table_${column.property}`]"
        >
          {{ column.label }}
        </div>
      </div>
      <div
        v-for="summary in mappedSummary"
        :key="summary.content"
        class="optimized-score-summary__summary-table_row"
      >
        <div
          v-for="column in tableConfig"
          :key="column.property"
          class="optimized-score-summary__summary-table_cell"
          :class="[`optimized-score-summary__summary-table_${column.property}`]"
          v-html="summary[column.property]"
        >
        </div>
      </div>
      <div class="optimized-score-summary__summary-table_row optimized-score-summary__summary-table_row-total">
        <div class="optimized-score-summary__summary-table_cell optimized-score-summary__summary-table_total">
          Total
        </div>
        <div class="optimized-score-summary__summary-table_cell optimized-score-summary__summary-table_score">
          {{ total }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

const DEFAULT_CONFIG = [
  {
    label: 'Element',
    property: 'content'
  },
  {
    label: 'Match type',
    property: 'match_type'
  },
  {
    label: 'Score',
    property: 'score'
  }
]
export default {
  name: 'OptimizedScoreSummary',
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMouseOver: false,
      listStyle: {},
      tableConfig: _.cloneDeep(DEFAULT_CONFIG)
    }
  },
  computed: {
    mappedSummary () {
      return ['title', 'headers', 'body', 'url'].map(key => {
        if (key !== 'headers') {
          return {
            content: key,
            match_type: this.summary[key].type,
            score: `${this.summary[key].score}/${this.summary[key].presence}`
          }
        } else {
          return {
            content: key,
            match_type: this.summary.primary_header_tag.type.toLowerCase() !== 'unmatched'
              ? `H1 ${this.summary[key].type}`
              : `H1 ${this.summary.primary_header_tag.type}<br/>H2 ${this.summary.secondary_header_tag.type}`,
            score: `${this.summary[key].score}/${this.summary[key].presence}`
          }
        }
      })
    },
    total () {
      let presence = 0
      let score = 0
      Object.values(['title', 'headers', 'body', 'url']).forEach(key => {
        presence += this.summary[key].presence
        score += this.summary[key].score
      })
      return `${score}/${presence}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .optimized-score-summary {
    padding: 22px 0 22px 20px;
    position: relative;

    &__summary-table {
      position: absolute;
      left: 50%;
      bottom: 80%;
      background-color: #fff;
      overflow: hidden;
      border-radius: $rfx-default-border-radius;
      box-shadow: 0 6px 16px 0 rgba(96, 97, 112, 0.2), 0 1px 4px 0 rgba(40, 41, 61, 0.06);

      &_content {
        width: 90px;
      }

      &_match_type {
        width: 110px;
      }

      &_total {
        width: 180px;
      }

      &_cell {
        font-size: 13px;
        color: #999;
        text-transform: capitalize;
        display: flex;
        align-items: center;
      }

      &_header {
        color: #636363;
        font-weight: bold;
        font-size: 13px;
      }

      &_row {
        display: flex;
        padding: 14px;
        width: -webkit-fill-available;
        border-bottom: 1px solid #f5f5f5;

        &-total {
          div {
            font-weight: bold;
          }
        }
      }
    }
  }
</style>
